namespace TabAurous.OMS {
    export namespace ProductPartyDetailsService {
        export const baseUrl = 'OMS/ProductPartyDetails';

        export declare function Create(request: Serenity.SaveRequest<ProductPartyDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductPartyDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductPartyDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ProductPartyDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/ProductPartyDetails/Create",
            Update = "OMS/ProductPartyDetails/Update",
            Delete = "OMS/ProductPartyDetails/Delete",
            Retrieve = "OMS/ProductPartyDetails/Retrieve",
            List = "OMS/ProductPartyDetails/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProductPartyDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
